/*global FakeCation*/
(function (FC) {
  "use strict";

  FC.utils.registerFilter('crop', function (imgData, cb, config) {
    var width = imgData.width,
        height = imgData.height,
        x, y,
        top = Infinity,
        left = Infinity,
        bottom = 0,
        right = 0,
        tmpBottom,
        tmpSide,
        offset,
        data = imgData.data,
        ctx = document.createElement('canvas').getContext('2d');

    ctx.canvas.width = imgData.width;
    ctx.canvas.height = imgData.height;
    ctx.putImageData(imgData, 0, 0);

    for (y = 0; y < height; y++) {
      for (x = 0; x < width; x++) {
        offset = (y * width + x) * 4;
        if (data[offset + 3] > 0) {
          if (y < top) {
            top = y;
          }
          if (y > bottom) {
            bottom = y;
          }

          if (x < left) {
            left = x;
          }

          if (x > right) {
            right = x;
          }
        }
      }
    }

    if (config && config.findBottom) {

      tmpSide = right;
      if (config.findBottom === 'left') {
        tmpSide = left;
      }

      tmpBottom = bottom;
      for (y = bottom; y > top && y > 4; y--) {
        offset = (y * width + tmpSide) * 4;

        if (data[offset + 3] > 0 && data[offset - width*4 + 3] === 0 && data[offset - 2 * width*4 + 3] === 0) {
          tmpBottom = y;
        }
      }

      if (!(tmpBottom <= 4) && !(tmpBottom === top)) {
        bottom = tmpBottom;
      }
    }

    cb(ctx.getImageData(left, top, right - left, bottom - top));

  });
}(FakeCation));
